export const constHeaders = [
  ["", "System", "Producentów", "500Hz", "1000Hz", "2000Hz", "4000Hz", "Opcje"],
  [
    "",
    "Producent",
    "Model",
    "Kalibracji",
    "500Hz",
    "1000Hz",
    "2000Hz",
    "4000Hz",
    "Opcje",
  ],
  ["", "Producent", "Modeli", "500Hz", "1000Hz", "2000Hz", "4000Hz", "Opcje"],
  ["", "System", "Producentów", "500Hz", "1000Hz", "2000Hz", "4000Hz", "Opcje"],
];
